import React, {useEffect, useRef, useState} from 'react';
import {Container, Row, Col} from 'reactstrap';
import {connect} from 'react-redux';
import {
  changeHandler,
  resetStore,
  validateHandler,
  onCheck,
  onUncheck,
  termsMsg,
  isCreditCardError,
  creditCardData,
  setId,
  setPaymentCount,
  getEMVStep1,
  getEMVStep2,
  initValidation,
  clearUrl,
  setTryAgainRequest,
  setCgIframeError,
} from './PaymentCGSlice';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import Loader from '../../../Shared/Loader/Loader';
import {hideAppLoader} from '../../../Shared/Loader/LoaderSlice';
import ReactSelect from '../../../Shared/ReactSelect/ReactSelect';
import {getRecaptchaToken} from './../../../../utilities/recaptcha/recaptcha';
import ThumbsUpAnimation from '../../../../animations/approved-checked-outline.json';
import Lottie from 'react-lottie';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import TermsOfUsePopup from '../../../Shared/TermsOfUsePopup/TermsOfUsePopup';
import Config from '../../../../Config';
import EpiContext from '@episerver/spa-core/Spa';
import {prepareUrl} from '../../../../utilities/StringHelpers/StringHelpers';
import './PaymentCG.scss';
import Image from 'app/Components/Shared/Image/image';

/** Desktop (mouse): blur iframe on parent scroll so CG native selects don't stay visually fixed. Touch / iOS: skip — blur breaks text focus & keyboard in the iframe. */
function shouldBlurIframeOnScrollToCloseCgSelects() {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia('(pointer: fine)').matches && window.matchMedia('(hover: hover)').matches;
}

const paymentCG = (props) => {
  const [selectedBlock, setSelectedBlock] = useState('payment');
  const [showTermsOfUse, setTermsOfUse] = useState(false);
  const [errorTitle, setErrorTitle] = useState(',הודעת שגיאה לגבי הכרטיס');
  const [iframeHeight, setIframeHeight] = useState(props.iframeHeight ? props.iframeHeight : 450);
  const sourceRef = useRef(props.source);
  const creditGuardIframeRef = useRef(null);
  useEffect(() => {
    sourceRef.current = props.source;
  }, [props.source]);
  var isInProcess = false;
  var handler;

  useExtendedEffect((runSideEffects) => {
    if (!runSideEffects()) {
      props.clearUrl();
      setSelectedBlock('payment');
      getEmvUrl();
    }
  }, []);

  useEffect(() => {
    if (props.onSubmit) {
      props.validateHandler(props.form);
    }
  }, [props.onSubmit]);

  useEffect(() => {
    if (props.form.valid != '' && props.CCToken !== undefined && props.CCToken !== '' && props.isShowTerms && props.onValid) {
      if (props.form.valid === true && props.isTermsAccepted === false) {
        props.termsMsg(true);
        props.onValid(false);
      }

      if (props.form.valid === true && props.isTermsAccepted === true) {
        props.termsMsg(false);
        props.onValid(true);
      }
    }

    props.initValidation();
  }, [props.form.valid]);

  useEffect(() => {
    if (selectedBlock !== 'payment') {
      return;
    }

    const closeIframeOpenDropdowns = () => {
      if (!shouldBlurIframeOnScrollToCloseCgSelects()) {
        return;
      }
      const iframeEl = creditGuardIframeRef.current;
      if (iframeEl) {
        iframeEl.blur();
      }
    };

    const scrollOptions = {capture: true, passive: true};

    const collectScrollTargets = (startNode) => {
      const targets = new Set();
      targets.add(window);
      if (document.scrollingElement) {
        targets.add(document.scrollingElement);
      }
      targets.add(document.documentElement);

      let el = startNode;
      while (el) {
        if (el instanceof HTMLElement) {
          const s = getComputedStyle(el);
          if (/(auto|scroll|overlay)/.test(s.overflowY) || /(auto|scroll|overlay)/.test(s.overflow)) {
            if (el.scrollHeight > el.clientHeight) {
              targets.add(el);
            }
          }
        }
        el = el.parentElement;
      }
      return targets;
    };

    const attachedScrollTargets = new Set();
    const frameId = requestAnimationFrame(() => {
      collectScrollTargets(creditGuardIframeRef.current).forEach((t) => {
        t.addEventListener('scroll', closeIframeOpenDropdowns, scrollOptions);
        attachedScrollTargets.add(t);
      });
    });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('scroll', closeIframeOpenDropdowns, scrollOptions);
    }

    return () => {
      cancelAnimationFrame(frameId);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('scroll', closeIframeOpenDropdowns, scrollOptions);
      }
      attachedScrollTargets.forEach((t) => {
        t.removeEventListener('scroll', closeIframeOpenDropdowns, scrollOptions);
      });
    };
  }, [selectedBlock, props.iframeUrl]);

  useEffect(() => {
    if (props.iframeUrl == '') {
      getEmvUrl();
    }
    props.setPaymentCount(props.numberOfPayments);
  }, []);

  useEffect(() => {
    if (props.form.errorObj != null) {
      props.hideAppLoader();
      const cgErrorIds = [9, 10, 800, 801, 802, 803, 804, 99];
      if (cgErrorIds.includes(props?.form?.errorObj?.errorId)) {
        //show cg error
        switch (props?.form?.errorObj?.errorId) {
          case 99:
            setErrorTitle('שגיאה כללית');
            break;
          case 9:
          case 10:
            setErrorTitle('פרטי אשראי שהוזנו לא תקינים');
            break;
          case 800:
            setErrorTitle('מספר תעודת זהות שגוי או לא תואם לכרטיס אשראי');
            break;
          case 801:
          case 802:
            setErrorTitle('פרטי אשראי שהוזנו לא תקינים');
            break;
          case 803:
            setErrorTitle('מצטערים, לא ניתן להשתמש בכרטיס לחיוב מיידי מסוג דביט/דיירקט');
            break;
          case 804:
            setErrorTitle('העסקה לא אושרה על ידי חברת אשראי');
            break;
        }
        setSelectedBlock('error');
        const resetTimer = window.setTimeout(() => {
          props.resetStore();
        }, 0);
        return () => window.clearTimeout(resetTimer);
      } else {
        //show general error on parent
        props.onError(props.form.errorObj.errorId);
      }
    }
  }, [props.form.errorObj]);

  useEffect(() => {
    props.hideAppLoader();
    if (props.form.confirmationNumber != '') setSelectedBlock('seccess');
  }, [props.form.confirmationNumber]);

  useEffect(() => {
    if (props.form.id === '') {
      props.setId(props.customerId);
    }

    addEventListener();

    const btnSubmit = document.querySelector('.sale-footer');
    if (btnSubmit) btnSubmit.style.display = 'none';

    props.initValidation();
  }, []);

  async function getEmvUrl() {
    const cToken = await getRecaptchaToken('paymentEMV');
    let customerId = '0';

    if (props.customerId && Config.cgShowIdNumber == 'True' && props.isShowIdNumber == true) {
      //for multiple ids in credit guard form please send array ['0372004333', '12344555', '041312224'] in customerId property
      if (Array.isArray(props.customerId)) {
        customerId = props.customerId.join(',');
      } else {
        customerId = props.customerId;
      }
    }

    props.getEMVStep1({
      type: props.type,
      id: customerId,
      totalPrice: props.totalPrice,
      numberOfPayments: props.numberOfPayments,
      token: cToken,
      isIDF: props.isIDF || false,
      source: props.source,
    });
  }

  async function callStep2(currentTotal, currentToken, personalId) {
    const cRrecaptchaToken = await getRecaptchaToken('paymentEMV2');
    let customerId = '0';

    if ((props.customerId || props.isNoIDNumberRequired) && Config.cgShowIdNumber == 'True' && props.isShowIdNumber == true) {
      if (Array.isArray(props.customerId) || props.isNoIDNumberRequired) {
        customerId = personalId; // multiple ids
      } else {
        customerId = props.customerId;
      }
    }

    const data = {
      type: props.type,
      total: currentTotal,
      token: currentToken,
      recaptchaToken: cRrecaptchaToken,
      isShowIdNumber: Config.cgShowIdNumber,
      id: customerId,
      blockId: props.blockId || '',
      isIDF: props?.isIDF || false,
      source: sourceRef.current,
    };
    props.getEMVStep2(data);
  }

  function addEventListener() {
    //listen to iframe messages from cg
    var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == 'attachEvent' ? 'onmessage' : 'message';

    handler = function (e) {
      if (e.data && e.data.height && !props.iframeHeight) {
        setIframeHeight(e.data.height);
      }

      var isSuccess = e.data.status == 'success';
      var isError = e.data.status == 'error';

      if (isSuccess) {
        props.clearUrl();

        if (props.totalPrice) callStep2(props.totalPrice, e.data.token, e.data.personalId);
        //debt
        else callStep2(100, e.data.token, e.data.personalId); //check

        removeListener();
        return;
      }

      if (isError) {
        props.hideAppLoader();
        const msg = typeof e.data?.message === 'string' ? e.data.message : '';
        props.setCgIframeError({
          errorId: 10,
          message: msg || 'CG iframe validation failed',
        });
        removeListener();
        return;
      }
    };

    eventer(messageEvent, handler);
  }

  function removeListener() {
    var cond = window.addEventListener;
    window[cond ? 'removeEventListener' : 'detachEvent'](cond ? 'message' : 'onmessage', handler);

    const btnSubmit = document.querySelector('.sale-footer');
    if (btnSubmit) {
      btnSubmit.style.display = 'block';
    }
  }
  useEffect(() => {
    if (props.edit || props.isThereTryAgainRequest) {
      tryAgain();
      if (props.isThereTryAgainRequest) {
        props.setTryAgainRequest(false);
      }
    }
  }, [props?.isIDFError, props.isPaymentErr]);

  function tryAgain() {
    setSelectedBlock('payment');
    props.clearUrl();
    getEmvUrl();
    addEventListener();
  }

  /*
  const paymentCountList = [
    {value: '1', label: 'תשלום אחד'},
    {value: '2', label: '2 תשלומים בקרדיט'},
    {value: '3', label: '3 תשלומים בקרדיט'},
    {value: '4', label: '4 תשלומים בקרדיט'},
    {value: '5', label: '5 תשלומים בקרדיט'},
    {value: '6', label: '6 תשלומים בקרדיט'},
    {value: '7', label: '7 תשלומים בקרדיט'},
    {value: '8', label: '8 תשלומים בקרדיט'},
    {value: '9', label: '9 תשלומים בקרדיט'},
    {value: '10', label: '10 תשלומים בקרדיט'},
  ];
  */

  const closeTermOfUse = () => {
    if (showTermsOfUse) {
      setTermsOfUse(false);
    }
  };

  // const getContinueText = () => {
  //   if (props.isSeparatedSale) return 'המשך';
  //   else if (props.isUpdatePayment) return 'עדכון וסיום';
  //   else return 'אישור תשלום';
  // };

  const getTermOfServiceText = () => {
    if (props.isSeparatedSale) {
      return (
        <p style={{lineHeight: 1.2, fontSize: '0.9rem'}}>
          הריני לאשר כי רכישת חבילות חו"ל ו/או כל רכישה אחרת תחויב באמצעות פרטי כרטיס אשראי אלה בנפרד מהחשבון החודשי{' '}
        </p>
      );
    } else {
      return (
        <p className='termOfService__link'>
          קראתי ואני מסכים{' '}
          <a href='#' onClick={() => setTermsOfUse(true)}>
            לעיקרי פרטי התכנית
          </a>
          ,{' '}
          <a href='#' onClick={() => setTermsOfUse(true)}>
            להסכם ההתקשרות
          </a>{' '}
          <a href='#' onClick={() => prepareUrl(props.generalTermsAgreementLink, EpiContext)}>
            ולתנאים הכלליים
          </a>
        </p>
      );
    }
  };

  return (
    <div>
      {props.isEmvStep2Pending ? (
        <div className='paymentCG'>
          <div className='payment-form'>
            <div className='pending-div'>
              <div className='pending-div__spinner-wrap'>
                <Image src={require('./images/loading.svg')} alt='' className='pending-div__spinner' width={56} height={56} />
              </div>
              <div>הכרטיס בבדיקה</div>
            </div>
          </div>
        </div>
      ) : (
        ''
      )}

      {selectedBlock == 'seccess' && props.form.confirmationNumber != '' && !props.isEmvStep2Pending ? (
        <Container className='paymentCG'>
          <Row>
            <Col style={{paddingLeft: '14px'}}>
              <div className='payment-form'>
                <Row>
                  <Col className='details'>
                    <div className='details__title'>פרטי תשלום</div>
                    <div className='details__ssl'>
                      רכישה מאובטחת ב-SSL <Image src={require('./images/lock.svg')} alt='מנעול' className='details__lock'></Image>
                    </div>
                  </Col>
                </Row>
                <Row className='cards'>
                  <Col>
                    <Image src={require('./images/cards.svg')} alt='כרטיסי אשראי' className='cards__img' />
                  </Col>
                  <Col className='cards__note'>
                    לא כולל
                    <br /> כרטיסי דיירקט
                  </Col>
                </Row>

                <div className='success-div'>
                  <div className='cgDone_img'>
                    <Image src={require('./images/check.svg')} alt='כרטיס אשראי' className='success-img' />
                  </div>
                  <div>הכרטיס מאושר</div>
                </div>
              </div>
            </Col>
          </Row>
          <br />
          <Row>
            <Col xs='12' md='12'>
              {props.isShowTerms && (
                <div className='termOfService'>
                  <div className='termOfService__checkbox'>
                    <CheckBox
                      id='approveReceivingMsg'
                      label={getTermOfServiceText()}
                      error={props.isTermsMsg ? 'חובה לאשר את תנאי השירות' : ''}
                      onCheck={(e) => props.onCheck({target: e.target, receiveMsgs: props.receiveMsgs})}
                      onUncheck={() => {
                        props.onUncheck();
                      }}></CheckBox>
                  </div>
                </div>
              )}
              {props.productsInfo.selectedProducts != undefined ? (
                <TermsOfUsePopup productsInfo={props.productsInfo} showTermsOfUse={showTermsOfUse} closeTermsOfUse={closeTermOfUse} />
              ) : (
                ''
              )}
            </Col>
          </Row>
        </Container>
      ) : (
        ''
      )}

      {selectedBlock == 'error' ? (
        <div className='paymentCG'>
          <div className='payment-form'>
            <div className='error-div'>
              <Image src={require('./images/error.svg')} alt='כרטיס אשראי' className='error-img'></Image>
              <div>{errorTitle}</div>

              <div type='button' onClick={tryAgain} className='link-btn'>
                ?ננסה כרטיס אחר
              </div>
            </div>
          </div>
        </div>
      ) : (
        ''
      )}

      {selectedBlock == 'payment' && !props.isEmvStep2Pending ? (
        <Container className='paymentCG'>
          <Loader overlay={true} />
          <Row>
            <Col style={{paddingLeft: '14px'}}>
              <div className='payment-form'>
                <Row>
                  <Col className='details'>
                    <div className='details__title'>פרטי תשלום</div>
                    <div className='details__ssl'>
                      רכישה מאובטחת ב-SSL <Image src={require('./images/lock.svg')} alt='מנעול' className='details__lock'></Image>
                    </div>
                  </Col>
                </Row>
                <Row className='cards'>
                  <Col>
                    <Image src={require('./images/cards.svg')} alt='כרטיסי אשראי' className='cards__img'></Image>
                  </Col>
                  {!props.isAllowDebit && (
                    <Col className='cards__note'>
                      לא כולל
                      <br /> כרטיסי דיירקט
                    </Col>
                  )}
                </Row>
                <div className='required-note'>
                  <span className='required-note__text'>
                    {props.isSeparatedSale ? 'כל השדות הינם שדות חובה' : 'שדות עם כוכבית הם חובה'}
                  </span>
                </div>
                <div className='form-container'></div>
                {/* {props.showPaymentCount ? (
                  <div className='select-holder'>
                    <ReactSelect
                      placeholderColor='#4a4a4a'
                      error={props.form.errors.subject}
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      placeholder='בחר סוג תשלום'
                      isLoading={false}
                      value={paymentCountList.filter((option) => option.value === props.form.paymentCount)}
                      name='paymentCount'
                      options={paymentCountList.slice(0, props.paymentRequestedQuantity ? props.paymentRequestedQuantity : 3)}
                      onChange={(e) =>
                        props.changeHandler({
                          target: {
                            name: 'paymentCount',
                            value: e.value,
                            label: e.label,
                          },
                          form: props.form,
                        })
                      }
                    />
                  </div>
                ) : null} */}
                <Row>
                  <Col style={{paddingRight: '14px'}}>
                    <iframe
                      ref={creditGuardIframeRef}
                      frameBorder='0'
                      scrolling='no'
                      className='nvc-iframe'
                      src={props.iframeUrl}
                      title=''
                      style={{height: iframeHeight ? `${iframeHeight}px` : '500px'}}></iframe>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      ) : (
        ''
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    form: state.PaymentCG.form,
    CCToken: state.PaymentCG.CCToken,
    isTermsAccepted: state.PaymentCG.isTermsAccepted,
    isTermsMsg: state.PaymentCG.isTermsMsg,
    CCError: state.PaymentCG.CCError,
    iframeUrl: state.PaymentCG.iframeUrl,
    productsInfo: state.saleBlock.productsInfo,
    generalTermsAgreementLink: state.saleBlock.epiServer.saleBlock.generalTermsAgreementLink,
    isThereTryAgainRequest: state.PaymentCG.isThereTryAgainRequest,
    isEmvStep2Pending: state.PaymentCG.isEmvStep2Pending,
  };
};

const mapDispatchToProps = {
  changeHandler,
  resetStore,
  validateHandler,
  onCheck,
  onUncheck,
  termsMsg,
  hideAppLoader,
  isCreditCardError,
  creditCardData,
  setId,
  setPaymentCount,
  getEMVStep1,
  getEMVStep2,
  initValidation,
  clearUrl,
  setTryAgainRequest,
  setCgIframeError,
};

export default connect(mapStateToProps, mapDispatchToProps)(paymentCG);
